import type { ReactNode } from "react";
import { Card, CardContent, Typography } from "@mui/material";

interface FormSectionCardProps {
  title: string;
  children: ReactNode;
}

export function FormSectionCard({ title, children }: FormSectionCardProps) {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
}
